// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ImageCropController from "./image_crop_controller";
application.register("image-crop", ImageCropController);

import PasswordGeneratorController from "./password_generator_controller";
application.register("password-generator", PasswordGeneratorController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import MapController from "./map_controller";
application.register("map", MapController);

import PhotoSourcePreviewController from "./photo_source_preview_controller";
application.register("photo-source-preview", PhotoSourcePreviewController);

import ProfileFormController from "./profile_form_controller";
application.register("profile-form", ProfileFormController);

import Dropdown from "@stimulus-components/dropdown";
application.register("dropdown", Dropdown);
